import React, { useState, useEffect  } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Box,
  Typography,
  Grid,
  Paper,
  Select,
  MenuItem,
} from "@mui/material";
import { dateDifference, formatDateText } from "../CommonFunctions";
import { CheckinForm } from "../CheckinForm";
import { ThreeDayNoticeForm } from "../ThreeDayNoticeForm";
import { get } from "jquery";
import { getDocumentTemplatesList } from "../TenancyApi";

export default function BookingOverview({tenancyId, tenancyDetails, customersDetails}) {

  const [showCheckinForm, setShowCheckinForm] = useState(false);
  const [showThreeDayNotice, setShowThreeDayNotice] = useState(false);
  const [showSevenDayNotice, setShowSevenDayNotice] = useState(false);

  const [documentTemplates, setDocumentTemplates] = useState([]); 


  useEffect(() => {
    getApiDocumentTemplatesList();
    
  }, [])

  const getApiDocumentTemplatesList = async () => {
    try{
      const templates = await getDocumentTemplatesList();
      setDocumentTemplates(templates);

    }catch(error){
      console.error("Error fetching document templates:", error);
    }
  }

  const handleFormChange = (e) => {
  const value = e.target.value;

  if (value === "checkin") {
    setShowCheckinForm(true);
  }

  if (value === "threeDayNotice") {
    setShowThreeDayNotice(true);
  }
  else if (value === 'sevenDayNotice') { 
    setShowSevenDayNotice(true)
  }
  else if (typeof value === 'number') {
    const url = `/api/templates/${value}/tenants/${tenancyId}/`;
    window.open(url, '_blank');
  }
  else if( value ==='notices' || value ==='court_documents'){
    const url = `/api/templates/categories/${value}/tenants/${tenancyId}/`;
    window.open(url, '_blank');
  }

};


    
  
  return (
    <>
      {/* TOP BOOKING OVERVIEW TABLE */}
      <Box px={4}>
        <TableContainer sx={{ boxShadow: "none", bgcolor: "#f7f7f7" }}>
          <Table
            sx={{
              "& td, & th": { border: "none", paddingY: 2, paddingX: 4 },
              "& thead th": { paddingBottom: "2px" },
              "& tbody td": { paddingTop: "2px" },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell>Room</TableCell>
                <TableCell>Booking ID</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Checkin Date</TableCell>
                <TableCell>Checkout Date</TableCell>
                <TableCell>Duration</TableCell>
                <TableCell>Forms</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              <TableRow>
                <TableCell>{tenancyDetails.roomid}</TableCell>
                <TableCell>{tenancyId}</TableCell>
                <TableCell
                  style={{
                    color:
                      tenancyDetails.status === "active"
                        ? "green"
                        : tenancyDetails.status === "checked-out"
                        ? "red"
                        : "inherit",
                    fontWeight: 600
                  }}
                >
                  {tenancyDetails.status || "—"}
                </TableCell>

                <TableCell><b>{formatDateText(tenancyDetails.checkin)}</b></TableCell>
                <TableCell><b>{formatDateText(tenancyDetails.checkout)}</b></TableCell>
                <TableCell><b>{dateDifference(tenancyDetails.checkin,tenancyDetails.checkout)} days</b></TableCell>
                <TableCell><Select
                    size="small"
                    defaultValue="none"
                    sx={{  minWidth: 130, height:25 }}
                    onChange={handleFormChange}
                  >
                    <MenuItem value="none">Select Forms</MenuItem>
                    <MenuItem value="checkin" >Checkin Form</MenuItem>
                    <MenuItem value="threeDayNotice">Three Day Notice</MenuItem>
                    <MenuItem value="sevenDayNotice">Seven Day Notice</MenuItem>
                    <MenuItem value="notices">Notices</MenuItem>
                    <MenuItem value="court_documents">Court Documents</MenuItem>
                    {documentTemplates && documentTemplates.length > 0 ? (
                    documentTemplates.map((template) => (
                      <MenuItem key={template.id} value={template.id}>
                        {template.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>Loading templates...</MenuItem>
                  )}



                  </Select></TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      {showCheckinForm && <CheckinForm
        value={{isCheckinFormVisible: showCheckinForm, 
          tenancyDetails, customersDetails}}  
        setIsCheckinFormVisible={setShowCheckinForm}
      />}
      {showThreeDayNotice && <ThreeDayNoticeForm
        value={{
          isCheckinFormVisible: showCheckinForm, 
          tenancyDetails, customersDetails
          
        }}
        setIsThreeDayNoticeFormVisible={setShowThreeDayNotice}
      /> }

    
    </>
  );
}
